import { generateOrderKeys, isOrderKey } from "../../../erd-editor-schema/dist/orderKey.js";
//#region src/engine/modules/dictionary/orderKeys.ts
function placeOrderKeys(rows, at, count) {
	let start = at;
	while (start > 0 && !isOrderKey(rows[start - 1].order)) start--;
	const low = start > 0 ? rows[start - 1].order : null;
	let end = at;
	while (low !== null && end < rows.length && isOrderKey(rows[end].order) && rows[end].order <= low) end++;
	const high = end < rows.length && isOrderKey(rows[end].order) ? rows[end].order : null;
	const before = rows.slice(start, at);
	const after = rows.slice(at, end);
	const keys = generateOrderKeys(low, high, before.length + count + after.length);
	const rekeyed = [];
	const rekey = (row, order) => {
		if (row.order !== order) rekeyed.push({
			id: row.id,
			order
		});
	};
	before.forEach((row, index) => rekey(row, keys[index]));
	after.forEach((row, index) => rekey(row, keys[before.length + count + index]));
	return {
		keys: keys.slice(before.length, before.length + count),
		rekeyed
	};
}
//#endregion
export { placeOrderKeys };
